import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5km4hkec0v: FaireBrandEntity = {
  token: "b_5km4hkec0v",
  type: "brand",
  name: "Eat Water",
  avatarUrl:
    "https://cdn.faire.com/fastly/c8123ee3e5a3c4c780c71e3203afd4d233786b25bc5fd43088d9af38ce1176a9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0397406c334ced52494337597893092f2debf724e39c9089f442a3fd20d3cb6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c8123ee3e5a3c4c780c71e3203afd4d233786b25bc5fd43088d9af38ce1176a9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0397406c334ced52494337597893092f2debf724e39c9089f442a3fd20d3cb6.png",
  location: "London, GBR",
  minimumOrderDollars: 30,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Welcome to our Eat Water Wholesale page. \n\nEat Water is a family run UK based health food producer founded in 2012. We specialise in innovative health foods mainly based on the ingredient Konjac or Shirataki. We have a range of foods that are Vegan, Keto, Gluten-Free, Organic, Zero Carbohydrate, Sugar-Free, Low Calorie, FODMAP, Paleo and more. \n\nVisit our store for zero carbohydrate pasta, noodles and rice that are organic and ready to cook. If you are interested in fresh meals with up to 90 day shelf life with no artificial ingredients, using the Swedish Mic Vac technology, then we have over 10 plant-based meals for you to choose from.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:48.325Z",
    importedBy: "entity-db-cli",
  },
};
